import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { OuiTableModule } from 'omnium-ui/table';
import { appRoutePaths } from '../../../../app.paths';
import { InvestorPersonMappingConflict } from '../../../../core/models/api.models';

@Component({
  selector: 'dbw-investor-person-mapping-conflicts-table',
  imports: [MatTableModule, OuiTableModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <oui-table class="data-table" [lineSizing]="'dense'">
      <table mat-table [dataSource]="conflicts()">
        <ng-container matColumnDef="investorId">
          <th mat-header-cell *matHeaderCellDef>Investisseur</th>
          <td mat-cell *matCellDef="let conflict">
            <a [routerLink]="appRoutePaths.atlas.investor(conflict.investor.investorId)">
              #{{ conflict.investor.investorId }}
            </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="displayName">
          <th mat-header-cell *matHeaderCellDef>Nom</th>
          <td mat-cell *matCellDef="let conflict">
            {{ conflict.investor.displayName || "Investisseur sans nom" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="investorCode">
          <th mat-header-cell *matHeaderCellDef>Code</th>
          <td mat-cell *matCellDef="let conflict">
            {{ conflict.investor.investorCode || "-" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="personIds">
          <th mat-header-cell *matHeaderCellDef>Personnes physiques Atlas</th>
          <td mat-cell *matCellDef="let conflict">
            {{ conflict.personnePhysiqueIds.join(", ") }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="conflictColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: conflictColumns"></tr>
      </table>
    </oui-table>
  `
})
export class InvestorPersonMappingConflictsTableComponent {
  readonly appRoutePaths = appRoutePaths;
  readonly conflicts = input.required<InvestorPersonMappingConflict[]>();
  readonly conflictColumns = ['investorId', 'displayName', 'investorCode', 'personIds'];
}
